var _g, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.286,
    height: 22.728,
    viewBox: "0 0 17.286 22.728",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Path_71",
    "data-name": "Path 71",
    transform: "translate(0 2.139)",
    fill: "none",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.286,3.993l-.714,13.1a3.773,3.773,0,0,1-4,3.494H4.714a3.773,3.773,0,0,1-4-3.494L0,3.993S13.571,3.884,17.286,3.993Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 11.15336227416992 5.444574356079102 C 7.665530204772949 5.444574356079102 3.717310905456543 5.467351913452148 1.583380699157715 5.481645584106445 L 2.21201229095459 17.0139331817627 C 2.213492393493652 17.04111289978027 2.214232444763184 17.06834411621094 2.214232444763184 17.09557342529297 C 2.214232444763184 18.19508361816406 3.335732460021973 19.08960342407227 4.714232444763184 19.08960342407227 L 12.57141208648682 19.08960342407227 C 13.94991207122803 19.08960342407227 15.07141208648682 18.19508361816406 15.07141208648682 17.09557342529297 C 15.07141208648682 17.06834411621094 15.07215213775635 17.04111289978027 15.07363224029541 17.0139331817627 L 15.70321369171143 5.4642333984375 C 14.57008934020996 5.451166152954102 13.04844856262207 5.444574356079102 11.15336227416992 5.444574356079102 M 11.15335845947266 3.944574356079102 C 13.71456146240234 3.944574356079102 16.0473747253418 3.956672668457031 17.28564262390137 3.992982864379883 L 16.57141304016113 17.09557342529297 C 16.57141304016113 19.0252742767334 14.78055191040039 20.58960342407227 12.57141208648682 20.58960342407227 L 4.714232444763184 20.58960342407227 C 2.505092620849609 20.58960342407227 0.7142314910888672 19.0252742767334 0.7142314910888672 17.09557342529297 L 1.9073486328125e-06 3.992982864379883 C 1.9073486328125e-06 3.992982864379883 6.031888008117676 3.944574356079102 11.15335845947266 3.944574356079102 Z",
    stroke: "none",
    fill: "#3a3a3a"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_74",
    "data-name": "Path 74",
    d: "M1254.714,799.786v8.8",
    transform: "translate(-1246.071 -789.766)",
    fill: "none",
    stroke: "#3a3a3a",
    strokeLinecap: "round",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_73",
    "data-name": "Path 73",
    d: "M1255.107,799.786l-.393,8.8",
    transform: "translate(-1242.286 -789.766)",
    fill: "none",
    stroke: "#3a3a3a",
    strokeLinecap: "round",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_75",
    "data-name": "Path 75",
    d: "M1254.714,799.786l.3,8.8",
    transform: "translate(-1250.155 -789.766)",
    fill: "none",
    stroke: "#3a3a3a",
    strokeLinecap: "round",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_77",
    "data-name": "Path 77",
    d: "M1268.667,791.75v-1.937a2.306,2.306,0,0,1,2.271-2.4h1.625a2.1,2.1,0,0,1,2.188,2.4v1.938",
    transform: "translate(-1263.065 -786.667)",
    fill: "none",
    stroke: "#3a3a3a",
    strokeLinecap: "round",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/deleteIcon.f1d9cf315d5cb2b5075e988cca951029.svg";
export { ForwardRef as ReactComponent };